<script>
import service from '@/service';
import _ from 'lodash';
import { parse } from 'date-fns';
import settings from '@/settings.js';
import * as Ladda from 'ladda';

export default {
	methods: {
		showModal: function (povraciloData) {
			this.clearForm();
			this.status_options = this.generateStatusOptions();
			if (!povraciloData) {
				this.addNew = true;
				this.$refs.modal.show();
			} else {
				this.modalPovraciloData.id = povraciloData.id;
				this.modalPovraciloData.id_vozila = povraciloData.id_vozila;
				if (povraciloData.creditnotedate) {
					this.modalPovraciloData.creditnotedate = parse(povraciloData.creditnotedate, settings.dbDtFormat);
				}
				this.modalPovraciloData.opomba = povraciloData.opomba;
				this.modalPovraciloData.status = povraciloData.status;
				this.selectedStatus.label = this.getStatusLabel(povraciloData.status);
				this.selectedStatus.value = povraciloData.status;
				this.selectedStatus.classStatus = this.getStatusClass(povraciloData.status);
				this.modalPovraciloData.chassis = povraciloData.chassis;
				this.modalPovraciloData.policy = povraciloData.policy;
				this.modalPovraciloData.campaign = povraciloData.campaign;
				this.modalPovraciloData.action_name = povraciloData.action_name;
				this.modalPovraciloData.sale_channel = povraciloData.sale_channel;
				this.modalPovraciloData.month = povraciloData.month;
				this.modalPovraciloData.amount = Number(povraciloData.amount);
				this.modalPovraciloData.numdoc = povraciloData.numdoc;
				this.modalPovraciloData.dealer_name = povraciloData.dealer_name;
				this.modalPovraciloData.discount = povraciloData.discount;
				this.modalPovraciloData.contribution = povraciloData.contribution;
				this.$refs.modal.show();
			}
		},
		generateStatusOptions: function () {
			let options = [];
			options.push({ label: 'Bi naj dobili', value: 0, classStatus: 'classStatus0' });
			options.push({ label: 'Smo zahtevali', value: 1, classStatus: 'classStatus1' });
			options.push({ label: 'Smo dobili', value: 2, classStatus: 'classStatus2' });
			options.push({ label: 'Modra', value: 3, classStatus: 'classStatus3' });
			return options;
		},
		getStatusLabel: function (status) {
			if (status === 0) {
				return 'Bi naj dobili';
			} else if (status === 1) {
				return 'Smo zahtevali';
			} else if (status === 2) {
				return 'Smo dobili';
			} else if (status === 3) {
				return 'Modra';
			}
		},
		getStatusValue: function (status) {
			if (status === 'Bi naj dobili') {
				return 0;
			} else if (status === 'Smo zahtevali') {
				return 1;
			} else if (status === 'Smo dobili') {
				return 2;
			} else if (status === 'Modra') {
				return 3;
			}
		},
		getStatusClass: function (status) {
			if (status === 0) {
				return 'classStatus0';
			} else if (status === 1) {
				return 'classStatus1';
			} else if (status === 2) {
				return 'classStatus2';
			} else if (status === 3) {
				return 'classStatus3';
			}
		},
		modal_okClick: function (evt) {
			evt.preventDefault();
			this.modalPovraciloData.status = this.selectedStatus.value;
			if ((this.modalPovraciloData.id_vozila === null || this.modalPovraciloData.id_vozila === 'null' || this.modalPovraciloData.id_vozila === '') && this.addNew) {
				this.showError('Poje Chassis je obvezno!');
			} else {
				service.addPovracilo(this.modalPovraciloData)
					.then(response => {
						if (this.addNew) {
							this.$emit('povracilo_add');
						} else {
							this.$emit('povracilo_edit');
						}
						this.$refs.modal.hide();
					})
					.catch(error => {
						this.showError('Napaka!');
						if (error) {
							console.log(error);
						}
					});
			}
		},
		modal_cancelClick: function (evt) {
			evt.preventDefault();
			this.$refs.modal.hide();
			setTimeout(() => {
				this.clearForm();
			}, 300);
		},
		showError: function (message) {
			if (message) {
				this.message.type = this.MESSAGE_TYPE_ERROR;
				this.message.text = message;
			} else {
				this.message.type = null;
				this.message.text = null;
			}
		},
		clearForm: function () {
			this.addNew = false;
			this.modalPovraciloData.id = 0;
			this.modalPovraciloData.id_vozila = null;
			this.modalPovraciloData.creditnotedate = null;
			this.modalPovraciloData.opomba = null;
			this.modalPovraciloData.status = null;
			this.modalPovraciloData.chassis = null;
			this.modalPovraciloData.policy = null;
			this.modalPovraciloData.campaign = null;
			this.modalPovraciloData.action_name = null;
			this.modalPovraciloData.sale_channel = null;
			this.modalPovraciloData.month = null;
			this.modalPovraciloData.amount = 0;
			this.modalPovraciloData.numdoc = null;
			this.modalPovraciloData.dealer_name = null;
			this.modalPovraciloData.discount = null;
			this.modalPovraciloData.contribution = null;
			this.selectedStatus.label = null;
			this.selectedStatus.value = null;
			this.selectedStatus.classStatus = null;
			this.ogrodja_options = [];
			this.message.type = null;
			this.message.text = null;
		},
		vozilaSelect_load: _.debounce((loading, search, vm) => {
			loading(true);
			service.searchVozila(search)
				.then(vozila => {
					loading(false);
					vm.ogrodja_options = vozila;
				})
				.catch(error => {
					loading(false);
					if (error) {
						console.log(error);
					}
				});
		}, 500),
		voziloSelect_change: function (value) {
			if (value != null) {
				this.modalPovraciloData.id_vozila = value.id;
				this.modalPovraciloData.chassis = value.ogrodje;
			} else {
				this.modalPovraciloData.id_vozila = null;
				this.modalPovraciloData.chassis = null;
			}
		},
		vozilaSelect_search: function (search, loading) {
			if (search && search !== '') {
				this.vozilaSelect_load(loading, search, this);
			}
		},
		click_updateData: function (ogrodje, evt) {
			this.showError();
			let loader = Ladda.create(this.$refs.aUpdate);
			loader.start();
			service.relateVoziloPovracilo(ogrodje, this.modalPovraciloData.id)
				.then(response => {
					loader.stop();
					if (response.status === 'ok') {
						this.showError();
						this.$emit('povracilo_id_vozila_find');
						this.modalPovraciloData.id_vozila = response.idVozila;
						this.$forceUpdate();
					} else {
						this.showError('Vozila ni v bazi!');
					}
				})
				.catch(error => {
					this.showError('Napaka!');
					if (error) {
						console.log(error);
					}
					loader.stop();
				});
		}
	},
	watch: {
	},
	data: function () {
		return {
			modalTitle: '',
			modalCancelTitle: 'Prekliči',
			modalErrorMsg: null,
			modalIsBusy: false,
			addNew: false,
			modalPovraciloData: {
				id: 0,
				creditnotedate: null,
				opomba: '',
				status: 0,
				znesek: 0,
				chassis: null,
				policy: null,
				campaign: null,
				action_name: null,
				sale_channel: null,
				month: null,
				amount: 0,
				numdoc: null,
				dealer_name: null,
				discount: 0,
				contribution: null
			},
			selectedStatus: {
				label: null,
				value: null,
				classStatus: null
			},
			status_options: [],
			ogrodja_options: [],
			message: {
				type: null,
				text: null
			},
			MESSAGE_TYPE_ERROR: 'ERROR'
		}
	},
	computed: {
		modalTitle_text () {
			if (this.modalPovraciloData.id === 0) {
				return 'Dodajanje povračila';
			}
			return 'Urejanje povračila';
		},
		ok_text () {
			if (this.modalPovraciloData.id === 0) {
				return 'Dodaj';
			}
			return 'Shrani';
		},
		message_class () {
			if (this.show_step_two) {
				return 'error_message_b';
			}
			return 'error_message';
		}
	},
	created () {
	}
}
</script>
<template>
	<b-modal ref="modal" class="modal-primary" @ok="modal_okClick" :title="modalTitle_text" :ok-title="ok_text" :cancel-title="modalCancelTitle" :busy="modalIsBusy">
		<b-form ref="form" novalidate>
			<app-mbox v-if="modalErrorMsg" :text="modalErrorMsg.message" @dismissed="clear_error_msg"></app-mbox>
			<b-row>
				<b-col v-if="!addNew">
					<b-form-group
						ref="formOgrodje"
						id="fieldset-Ogrodje"
						label-cols="3"
						label="Chassis"
						label-for="chassis">
						<div v-if="modalPovraciloData.id_vozila == null" class="noVIN chassisText">
							{{ modalPovraciloData.chassis }}
							<b-button class="updateDataButton" ref="aUpdate" data-style="zoom-in" size="sm" title="Poveži povračilo z importdata" @click.stop="click_updateData(modalPovraciloData.chassis, $event)">
								<i class="fa fa-file ladda-label"></i>
							</b-button>
						</div>
						<div v-else class="chassisText">
							{{ modalPovraciloData.chassis }}
						</div>
					</b-form-group>
				</b-col>
				<b-col v-else>
					<b-form-group
						id="fieldset-Ogrodje"
						label-cols="3"
						label="Chassis"
						label-for="chassis">
						<v-select v-model="modalPovraciloData.chassis"
							id="ogrodje" 
							label="ogrodje"
							:options="ogrodja_options"
							:taggable="true"
							:filterable="false"
							@input="voziloSelect_change($event)"
							@search="vozilaSelect_search"
							placeholder="Izberi vozilo ...">
							<template slot="no-options">Vnesite VIN številko vozila</template>
						</v-select>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col>
					<b-form-group
						id="fieldset-horizontal"
						label-cols="3"
						label="Creditnotedate"
						label-for="datum">
						<v-date-picker v-if="modalPovraciloData.id >= 0"
							ref="datum"
							id="datum"
							:max-date="new Date(Date.now())"
							v-model="modalPovraciloData.creditnotedate"
							:is-required="true"
							:input-props='{
								class: "form-control dt_border gdt_border",
								placeholder: "DD. MM. YYYY",
								required: true
							}'
							mode="single"
							locale="sl-SI" />
						<b-form-input id="datum" v-else type="text" :value="modalPovraciloData.creditnotedate | hr_date" disabled></b-form-input>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col>
					<b-form-group
						id="fieldset-Policy"
						label-cols="3"
						label="Policy"
						label-for="policy">
						<b-form-input class="form-control" type="text" id="policy" v-model="modalPovraciloData.policy"></b-form-input>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col>
					<b-form-group
						id="fieldset-Campaign"
						label-cols="3"
						label="Campaign"
						label-for="campaign">
						<b-form-input class="form-control" type="text" id="campaign" v-model="modalPovraciloData.campaign"></b-form-input>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col>
					<b-form-group
						id="fieldset-Action_name"
						label-cols="3"
						label="Action name"
						label-for="action_name">
						<b-form-input class="form-control" type="text" id="action_name" v-model="modalPovraciloData.action_name"></b-form-input>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col>
					<b-form-group
						id="fieldset-Sale_channel"
						label-cols="3"
						label="Sale channel"
						label-for="sale_channel">
						<b-form-input class="form-control" type="text" id="sale_channel" v-model="modalPovraciloData.sale_channel"></b-form-input>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col>
					<b-form-group
						id="fieldset-Month"
						label-cols="3"
						label="Month"
						label-for="month">
						<b-form-input class="form-control" type="text" id="month" v-model="modalPovraciloData.month"></b-form-input>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col>
					<b-form-group
						id="fieldset-Amount"
						label-cols="3"
						label="Amount"
						label-for="amount">
						<currency-input class="form-control" type="text" id="amount" v-model="modalPovraciloData.amount"></currency-input>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col>
					<b-form-group
						id="fieldset-Numdoc"
						label-cols="3"
						label="Numdoc"
						label-for="numdoc">
						<b-form-input class="form-control" type="text" id="numdoc" v-model="modalPovraciloData.numdoc"></b-form-input>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col>
					<b-form-group
						id="fieldset-Dealer_name"
						label-cols="3"
						label="Dealer name"
						label-for="dealer_name">
						<b-form-input type="text" id="dealer_name" v-model="modalPovraciloData.dealer_name"></b-form-input>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col>
					<b-form-group
						id="fieldset-Discount"
						label-cols="3"
						label="Discount"
						label-for="discount">
						<b-form-input type="text" id="discount" v-model="modalPovraciloData.discount"></b-form-input>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col>
					<b-form-group
						id="fieldset-Contribution"
						label-cols="3"
						label="Contribution"
						label-for="contribution">
						<b-form-input type="text" id="contribution" v-model="modalPovraciloData.contribution"></b-form-input>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col>
					<b-form-group
						id="fieldset-Opomba"
						label-cols="3"
						label="Opomba"
						label-for="opomba">
						<b-form-input class="form-control" type="text" id="opomba" v-model="modalPovraciloData.opomba"></b-form-input>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col>
					<b-form-group
						id="fieldset-Status"
						label-cols="3"
						label="Status"
						label-for="status">
						<b-row>
							<b-col cols="1">
								<span class="fa statusColor" :class="selectedStatus.classStatus"></span>
							</b-col>
							<b-col>
								<v-select :options="status_options" label="label" v-model="selectedStatus">
								<template slot="option" slot-scope="option">
									<span class="fa icon" :class="option.classStatus"></span>
									{{ option.label }}
								</template>
							</v-select>
							</b-col>
						</b-row>
					</b-form-group>
				</b-col>
			</b-row>
		</b-form>
		<b-alert :class="message_class" :variant="message.type && message.type === MESSAGE_TYPE_ERROR ? 'danger' : 'primary'" :show="message.text && message.text !== ''">{{ message.text }}</b-alert>
	</b-modal>
</template>
<style scoped>
@import '../../../node_modules/ladda/dist/ladda-themeless.min.css';

.b_table {
	margin-bottom: o;
}
.ma_pos {
	text-align: end;
}
.noVIN {
	color: red;
}
.error_message {
	margin-top: 1rem;
	margin-bottom: 0;
}
.error_message_b {
	margin: 1rem;
}
</style>
<style>
.no_padding {
	padding: 0;
	margin: 0;
}
.custom-file-input ~ .custom-file-label::after {
	content: 'Izberi';
}
.chassisText {
	padding: 10px;
}
.updateDataButton {
	float: right;
}
.classStatus0 {
	background-color: #f0f3f5;
	color: 151b1e;
}
.classStatus1 {
	background-color: #ffc107;
	color: #fff;
}
.classStatus2 {
	background-color: #4dbd74;
	color: #fff;
}
.classStatus3 {
	background-color: #20a8d8;
	color: fff;
}
.icon {
	margin-left: 0px;
	padding: 5px;
}
.statusColor {
	margin: 3px;
	padding: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/Modals/EditPovraciloModal.vue